export const TESTID_SOURCE_STEP = 'citation-flow-source-step'
export const TESTID_FORM_STEP = 'citation-flow-form-step'
export const TESTID_SOURCE_STEP_TITLE = 'source-title'
export const TESTID_FORM_STEP_TITLE = 'form-title'
export const ERROR_MESSAGE_PROJECT_NOT_FOUND = 'Project not found!'
